<template>
    <div>
        <SaveProgress 
            v-if="!isFirstStep && hasProgression"

            btn-class="w-full md:hidden mt-3"
        
            :disabled="loading" 
        />

        <div 
            class="gap-2 justify-between w-full mt-3"
            :class="{
                'grid grid-cols-[1fr] sm:grid-cols-2 md:flex': !isFirstStep,
                'flex': isFirstStep
            }"
        >
            <div class="">
                <button 
                    v-if="!isFirstStep"

                    :disabled="loading"
                    
                    class="btn btn--primary-hollow"

                    @click="onPrevious"
                >{{ previousStepLabel }}</button>
            </div>

            <div class="flex gap-x-2">
                <SaveProgress 
                    v-if="!isFirstStep && hasProgression"

                    btn-class="!hidden md:!flex"
                
                    :disabled="loading" 
                />
                
                <LoaderButton 
                    class="btn"
                    :class="nextStepClass"

                    :disabled="!canContinue"

                    @click="onNext"

                    :loading="loading"
                >
                    {{ isLastStep ? submissionLabel : nextStepLabel }}
                </LoaderButton>
            </div>
        </div>
    </div>
</template>

<script>
import LoaderButton from "./LoaderButton.vue"
import SaveProgress from "./SaveProgress.vue"

export default {
    components: { 
        LoaderButton, 
        SaveProgress 
    },

    props: {
        loading : Boolean,

        submissionLabel: {
            type    : String,
            default : 'Confirm Details'
        },

        nextStepLabel: {
            type    : String,
            default : 'Next Step'
        },

        previousStepLabel: {
            type    : String,
            default : 'Previous Step'
        },

        nextStepClass: {
            type    : String,
            default : 'btn--green'
        },

        hasProgression: {
            type    : Boolean,
            default : true
        },

        isValid: {
            type    : Boolean,
            default : true
        },

        isFirstStep: {
            type: Boolean,
            default: true
        },

        isLastStep: {
            type: Boolean,
            default: false
        },
    },

    computed: {
        canContinue: function(){
            return this.isValid && !this.loading
        }
    },
    
    methods: {
        onPrevious: function () {
            this.$emit("previous");
        },
        onNext: function () {
            this.$emit("next");
        }
    },
}
</script>